module.exports = __webpack_public_path__ + "img/img18.44762dcf.svg";